export class appWindow {
    // #region Values
    appHost;
    component;
    windowId;
    parent;
    title;
    options;
    metaTags;
    // #endregion
    // #region Constructor
    constructor(appHost, component, parent = undefined) {
        this.windowId = component.$.uid;
        this.component = component;
        this.appHost = appHost;
        this.parent = parent;
    }
    // #endregion
    // #region Functions
    setTitle(title) {
        // #region Set
        this.title = title;
        // #endregion
        // #region Host
        this.appHost.pageMeta.title = title;
        // #endregion
    }
    setOptions(options) {
        // #region Self
        this.options = options;
        // #endregion
        // #region Host
        this.appHost.pageMeta.options = options;
        // #endregion
    }
    setMeta(data) {
        if (data?.title) {
            this.setTitle(data.title);
        }
        if (data?.meta) {
            this.setMetaTags(data.meta);
        }
    }
    setMetaTags(metatags) {
        // #region Self
        this.metaTags = metatags;
        // #endregion
        // #region Host
        this.appHost.pageMeta.setMeta({ meta: metatags });
        // #endregion
    }
    async close(state, result = null, tag = null, error = null) {
        // #region Run
        // #endregion        
    }
    // #endregion
    // #region Lifecylce
    mount() {
        if (this.title) {
            this.appHost.pageMeta.title = this.title;
        }
    }
    unmount() {
        // #region Find
        let tWindow = this.parent;
        {
            while (tWindow) {
                if (tWindow.title) {
                    break;
                }
                else if (tWindow.parent) {
                    tWindow = tWindow.parent;
                }
                else {
                    break;
                }
            }
        }
        if (tWindow?.title) {
            this.appHost.pageMeta.title = tWindow?.title;
        }
        // #endregion
    }
}
